import { Box, Grid, Stack, ToggleButton, ToggleButtonGroup, Typography, styled, Tooltip } from "@mui/material";
import React, { useState } from "react";
import GeneralTable from "../Table/TableGeneral";

const TitleBox = styled(Box)(
    ({ theme }) => `
        width: 100%;
        border: 1px solid #aaa;
        padding: 0.5rem;
        border-radius: 4px;
        overflow: hidden;
    `
)

const CustomToggleButtonGroup = styled(ToggleButtonGroup)(
    ({ theme }) => `
        border-radius: 200px;
        width: 100%;
    `
)

const CustomToggleButton = styled(ToggleButton)(
    ({ theme }) => `
        border-radius: 200px;
        width: 100%;
        &.Mui-selected {
            background: ${theme.palette.teritiary.main};
            color: white;
            &:hover {
                background: ${theme.palette.teritiary.main};
                color: white;
            }
        }
       
    `
)

export default function EoiDataBlock({ noSpacing, data }) {

    const [alignment, setAlignment] = useState(data.item[0].eoI_Status);

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment !== null) {
            setAlignment(newAlignment);
        }
    }

    return (
        <Grid item xs={window.innerWidth > 991 ? 4 : 12} sx={{pl: noSpacing ? "0 !important" : "1rem !important"}}>
            <Stack spacing={2}>
                <TitleBox>
                    <Tooltip title={data.visa_type}>
                        <Typography variant="caption" noWrap >{data.visa_type}</Typography>
                    </Tooltip>
                </TitleBox>
                <CustomToggleButtonGroup
                    value={alignment}
                    exclusive={true}
                    onChange={handleAlignment}
                    sx={{direction: "ltr !important"}}
                >
                    {
                        data.item.map((val, i) => {
                            return (
                                <CustomToggleButton key={i} value={val.eoI_Status}>
                                    <Typography variant="caption">{val.eoI_Status}</Typography>
                                </CustomToggleButton>
                            )
                        })
                    }
                </CustomToggleButtonGroup>
                <GeneralTable
                    section="eoiData" 
                    data={data.item.filter(e => e.eoI_Status == alignment)[0]?.points}
                />

            </Stack>
        </Grid>
    )
}
